import React, { Component } from 'react';
import Select from 'react-select';
import axios from 'axios';

import 'react-select/dist/react-select.css';

class SelectRemoteWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      optionsSelect: [],
    };
  }

  componentWillMount() {
    let _this = this;
    axios
      .get(this.props.schema.api)
      .then(function (result) {
        var selectData = [];
        result.data.map(function (item) {
          selectData.push({
            value: item[_this.props.schema.options.value],
            label: item[_this.props.schema.options.label],
          });
        });

        _this.setState({ optionsSelect: selectData });
      })
      .catch(function (error) {
        console.log('Error: ', error);
      });

    //          onChange={(event) => ((event) !== null ? this.props.onChange(event.value) : this.props.onChange("")) }
  }

  render() {
    return (
      <div>
        <Select
          placeholder={this.props.schema.title}
          name="singleSelect"
          value={this.props.value}
          options={this.state.optionsSelect}
          required={this.props.required}
          onChange={(event) =>
            event !== null
              ? this.props.onChange(event.value)
              : this.props.onChange('')
          }
        />
      </div>
    );
  }
}

export default SelectRemoteWidget;



// WEBPACK FOOTER //
// ./src/lib/widget-selectRemote.js